/**
 * Toasts and confirmations for code that has no component instance — Vuex
 * modules, the axios interceptor, plain factories. Components should use the
 * canToast and canConfirm mixins instead; this reaches the same PrimeVue
 * services those mixins use.
 *
 * main.js hands the services over once the app exists, so nothing here works
 * before then.
 */
let toastService = null
let confirmService = null

export const registerNotificationServices = ({ toast, confirm }) => {
    toastService = toast
    confirmService = confirm
}

/**
 * @param {string} summary
 * @param {string} severity success | info | warn | error
 * @param {number} life how long it stays up, in milliseconds
 */
export const notify = (summary, severity = 'error', life = 4000) => {
    toastService?.add({ severity, summary, life })
}

/**
 * Resolves true when the user accepts, false when they decline or dismiss.
 * Mirrors the canConfirm mixin, including `rejectLabel: null` to drop the
 * decline button.
 *
 * @param {object} options
 * @returns {Promise<boolean>}
 */
export const confirm = (options) => {
    // Accepts a bare string for the same reason the canConfirm mixin does.
    const {
        message,
        hint = null,
        header = null,
        acceptLabel = 'Yes',
        rejectLabel = 'Cancel',
        danger = false,
    } = typeof options === 'string' ? { message: options } : options

    return new Promise((resolve) => {
        if (!confirmService) {
            resolve(false)
            return
        }

        confirmService.require({
            header,
            message,
            hint,
            acceptLabel,
            rejectLabel,
            danger,
            accept: () => resolve(true),
            reject: () => resolve(false),
            onHide: () => resolve(false),
        })
    })
}
